import Bowser from 'bowser'

const GetBrowserNameFromUserAgent = (userAgentString) => {
  const browser = Bowser.getParser(userAgentString)
  return browser.getBrowserName()
}

export default GetBrowserNameFromUserAgent
